import { Injectable } from '@angular/core';
import { Przystanek } from './stops.component';

@Injectable()
export class StopsService {

  przystanekAutobusowy: Array<Przystanek> = [];

  constructor() {
    let tmp: Przystanek = ({ id: 1, name: '1 Maja' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 2, name: '1 Maja / Bat. Chłopskich' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 3, name: '1 Maja / Łódzka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 4, name: '1 Maja / Miła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 5, name: '1 Maja os. Herby' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 6, name: 'al. Górników Staszicowskich' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 7, name: 'al. Górników Staszicowskich I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 8, name: 'al. IX W. Kielc kościół św.Wojciecha' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 9, name: 'al. IX Wieków Kielc' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 10, name: 'al. IX Wieków Kielc szpital' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 11, name: 'al. IX Wieków Kielc UM' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 12, name: 'al. IX Wieków Kielc UW' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 13, name: 'al. Legionów Kadzielnia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 14, name: 'al. Legionów stadion' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 15, name: 'al. Na Stadion' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 16, name: 'al. Na Stadion / Kusocińskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 17, name: 'al. Na Stadion / Szczepaniaka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 18, name: 'al. Na Stadion I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 19, name: 'al. Popiełuszki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 20, name: 'al. Popiełuszki / Wapiennikowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 21, name: 'al. Popiełuszki / Wrzosowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 22, name: 'al. Solidarności Galeria "Echo"' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 23, name: 'al. Solidarności / al. Tysiąclecia PP' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 24, name: 'al. Solidarności / os. Bocianek' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 25, name: 'al. Solidarności / Sandomierska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 26, name: 'al. Szajnowicza - Iwanowa / Puscha' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 27, name: 'al. Szajnowicza - Iwanowa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 28, name: 'al. Szajnowicza - Iwanowa II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 29, name: 'al. Szajnowicza - Iwanowa III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 30, name: 'al. Tysiąclecia PP' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 31, name: 'al. Tysiąclecia PP / Wiejska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 32, name: 'Aleksandrówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 33, name: 'Ameliówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 34, name: 'Armii Krajowej' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 35, name: 'Artwińskiego przychodnia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 36, name: 'Artwińskiego szpital' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 37, name: 'Barcza I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 38, name: 'Barcza pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 39, name: 'Bat. Chłopskich' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 40, name: 'Bat. Chłopskich / 1 Maja' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 41, name: 'Bat. Chłopskich / Zakładowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 42, name: 'Bat. Chłopskich I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 43, name: 'Bat. Chłopskich III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 44, name: 'Bat. Chłopskich IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 45, name: 'Bat. Chłopskich kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 46, name: 'Bat. Chłopskich pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 47, name: 'Bat. Chłopskich V' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 48, name: 'Bazylika Katedralna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 49, name: 'Bęczków' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 50, name: 'Bęczków Niwy I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 51, name: 'Bęczków Niwy II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 52, name: 'Bęczków Niwy III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 53, name: 'Bieleckie Młyny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 54, name: 'Bilcza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 55, name: 'Bilcza / Kowala' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 56, name: 'Bilcza Folwark' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 57, name: 'Bilcza I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 58, name: 'Bilcza II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 59, name: 'Bilcza III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 60, name: 'Bilcza Podgórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 61, name: 'Bilcza Podgórze I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 62, name: 'Bilcza szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 63, name: 'Boh. Warszawy / Szymanowskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 64, name: 'Boh. Warszawy / Tarnowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 65, name: 'Bolechowice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 66, name: 'Bolechowice szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 67, name: 'Brudzów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 68, name: 'Brudzów Duży' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 69, name: 'Brudzów osiedle' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 70, name: 'Brynica' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 71, name: 'Brynica I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 72, name: 'Brynica II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 73, name: 'Brynica szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 74, name: 'Brzezinki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 75, name: 'Brzezinki cmentarz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 76, name: 'Brzezinki I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 77, name: 'Brzezinki III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 78, name: 'Brzezinki pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 79, name: 'Brzezinki szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 80, name: 'Brzeziny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 81, name: 'Brzeziny VI' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 82, name: 'Brzeziny I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 83, name: 'Brzeziny II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 84, name: 'Brzeziny III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 85, name: 'Brzeziny IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 86, name: 'Brzeziny kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 87, name: 'Brzeziny pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 88, name: 'Brzeziny V' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 89, name: 'Brzeziny VII' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 90, name: 'Bukówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 91, name: 'Cedzyna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 92, name: 'Cedzyna Cedro Mazur' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 93, name: 'Cedzyna cmentarz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 94, name: 'Cedzyna I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 95, name: 'Cedzyna II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 96, name: 'Cedzyna zalew' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 97, name: 'Chałupki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 98, name: 'Chęciny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 99, name: 'Chęciny cmentarz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 100, name: 'Chęciny szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 101, name: 'Chęciny ul.Armii Krajowej' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 102, name: 'Chęciny ul.Małogoska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 103, name: 'Chęciny ul.Szkolna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 104, name: 'Chorzowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 105, name: 'Chorzowska / Posłowicka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 106, name: 'Chorzowska / Trzuskawica' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 107, name: 'Chorzowska / Ustronie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 108, name: 'Chorzowska / Zagrabowicka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 109, name: 'Chorzowska II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 110, name: 'Chorzowska Stacja PKP' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 111, name: 'Chrusty' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 112, name: 'Chrusty PKP' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 113, name: 'Chrusty szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 114, name: 'Ciekoty' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 115, name: 'Ciekoty I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 116, name: 'Ciekoty II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 117, name: 'Ciekoty III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 118, name: 'Ciekoty schronisko' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 119, name: 'Ciekoty zalew' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 120, name: 'Cmentarna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 121, name: 'Czarnowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 122, name: 'Czarnowska PKS' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 123, name: 'Czerwona Góra' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 124, name: 'Czerwona Góra szpital' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 125, name: 'Częstochowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 126, name: 'Częstochowska Urząd Skarbowy' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 127, name: 'Ćmińsk' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 128, name: 'Ćmińsk / Kobylaki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 129, name: 'Ćmińsk / Sienkiewicza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 130, name: 'Ćmińsk stacja paliw' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 131, name: 'Ćmińsk szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 132, name: 'Daleszyce / Sienkiewicza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 133, name: 'Daleszyce rynek' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 134, name: 'Daleszyce szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 135, name: 'Daleszycka GEOPARK' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 136, name: 'Dąbrowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 137, name: 'Dębska Wola' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 138, name: 'Dębska Wola I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 139, name: 'Długa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 140, name: 'Długa / Częstochowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 141, name: 'Długa / Skrajna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 142, name: 'Dobromyśl' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 143, name: 'Dobromyśl / Janowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 144, name: 'Dobromyśl ogródki działkowe' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 145, name: 'Dolina Marczakowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 146, name: 'Dolina Marczakowa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 147, name: 'Dolina Marczakowa II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 148, name: 'Dolina Marczakowa III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 149, name: 'Dolina Marczakowa IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 150, name: 'Dolina Marczakowa V' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 151, name: 'Domaszowice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 152, name: 'Domaszowice / Sandomierska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 153, name: 'Domaszowice I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 154, name: 'Domaszowice Na Górze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 155, name: 'Domaszowice ogródki działkowe' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 156, name: 'Domaszowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 157, name: 'Domaszowska / Morcinka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 158, name: 'Domaszowska / Poleska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 159, name: 'Domaszowska / Zbożowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 160, name: 'Domaszowska WORD' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 161, name: 'Dyminy Granice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 162, name: 'Dyminy Granice I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 163, name: 'Fabryczna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 164, name: 'Fabryczna kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 165, name: 'Fosforytowa kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 166, name: 'Gawronki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 167, name: 'Gosiewskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 168, name: 'Górki Szczuk.szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 169, name: 'Górki Szczukowskie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 170, name: 'Górna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 171, name: 'Górno' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 172, name: 'Górno / ośrodek zdrowia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 173, name: 'Górno / Salon maszyn' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 174, name: 'Górno / za drogą 74' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 175, name: 'Górno Bór' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 176, name: 'Górno I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 177, name: 'Górno II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 178, name: 'Górno parcele / kolejka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 179, name: 'Górno rz. Warkocz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 180, name: 'Górno szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 181, name: 'Górno UG' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 182, name: 'Grunwaldzka / Jagiellońska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 183, name: 'Grunwaldzka / Mielczarskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 184, name: 'Grunwaldzka / os. Pod Dalnią' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 185, name: 'Grunwaldzka / Piekoszowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 186, name: 'Grunwaldzka szpital' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 187, name: 'Gruszka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 188, name: 'Gruszka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 189, name: 'Gruszka PKS' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 190, name: 'Gruszka szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 191, name: 'Hoża' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 192, name: 'Hubalczyków' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 193, name: 'Hubalczyków / Gruchawka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 194, name: 'Hubalczyków elektrociepłownia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 195, name: 'Husarska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 196, name: 'Husarska / Szczepaniaka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 197, name: 'Jagiellońska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 198, name: 'Jagiellońska / Artwińskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 199, name: 'Jagiellońska / Chałubińskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 200, name: 'Jagiellońska / Karczówkowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 201, name: 'Jagiellońska / Miła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 202, name: 'Jagiellońska / Piekoszowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 203, name: 'Jagiellońska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 204, name: 'Jagiellońska MPK' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 205, name: 'Jagiellońska os. Czarnów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 206, name: 'Jana Pawła II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 207, name: 'Janów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 208, name: 'Janów / Ślazy' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 209, name: 'Janów Dolny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 210, name: 'Jaskinia Raj' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 211, name: 'Jaworskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 212, name: 'Jaworskiego / os. Słoneczne Wzgórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 213, name: 'Jaworznia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 214, name: 'Jaworznia / Fabryczna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 215, name: 'Jaworznia Kostówki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 216, name: 'Jaworznia szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 217, name: 'Jesionowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 218, name: 'Jesionowa / Zagnańska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 219, name: 'Kaczmarka / Krakowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 220, name: 'Kajetanów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 221, name: 'Kajetanów pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 222, name: 'Kajetanów/pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 223, name: 'Kalinowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 224, name: 'Karczówkowska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 225, name: 'Karczówkowska II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 226, name: 'Kielecki Park Technologiczny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 227, name: 'Klecka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 228, name: 'Klonowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 229, name: 'Klonowa / Turystyczna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 230, name: 'Klonowa os. Szydłówek' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 231, name: 'Kobylaki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 232, name: 'Kobylaki I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 233, name: 'Kolberga' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 234, name: 'Kolonia I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 235, name: 'Kolonia II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 236, name: 'Kołłątaja' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 237, name: 'Kołomań' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 238, name: 'Kongresowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 239, name: 'Kostomłoty' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 240, name: 'Kostomłoty II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 241, name: 'Kostomłoty III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 242, name: 'Kostomłoty IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 243, name: 'Kostomłoty kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 244, name: 'Kostomłoty Maciejówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 245, name: 'Kostomłoty obwodnica' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 246, name: 'Kostomłoty pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 247, name: 'Kostomłoty Pierwsze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 248, name: 'Kostomłoty szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 249, name: 'Kostomłoty V' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 250, name: 'Kostomłoty VI' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 251, name: 'Kostomłoty VII' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 252, name: 'Kowala' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 253, name: 'Kowala II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 254, name: 'Kowala szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 255, name: 'Kowala I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 256, name: 'Kowala Mała' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 257, name: 'Krajno' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 258, name: 'Krajno Drugie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 259, name: 'Krajno Drugie / rzeka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 260, name: 'Krajno I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 261, name: 'Krajno III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 262, name: 'Krajno Parcele / skrz. Wymyślona' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 263, name: 'Krajno Parcele II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 264, name: 'Krajno Pierwsze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 265, name: 'Krajno Pierwsze / Pomnik' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 266, name: 'Krajno Pierwsze / Taras widokowy' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 267, name: 'Krajno Pierwsze I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 268, name: 'Krajno Pierwsze II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 269, name: 'Krajno Zagórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 270, name: 'Krajno Zagórze I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 271, name: 'Krajno Zagórze II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 272, name: 'Krajno Zagórze III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 273, name: 'Krajno Zagórze IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 274, name: 'Krajno Zagórze Pierwsze / Krajno Wymyślona' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 275, name: 'Krakowska / Chorzowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 276, name: 'Krakowska / Jana Pawła II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 277, name: 'Krakowska / Stokowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 278, name: 'Krakowska Białogon' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 279, name: 'Krakowska Biesak' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 280, name: 'Krakowska Bruszniowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 281, name: 'Krakowska Kadzielnia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 282, name: 'Krakowska MPK' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 283, name: 'Krakowska os. Podkarczówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 284, name: 'Krakowska Słowik' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 285, name: 'Krakowska szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 286, name: 'Krakowska UJK' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 287, name: 'Krakowska wiadukt' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 288, name: 'Kranów I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 289, name: 'Kranów II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 290, name: 'Kruszelnickiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 291, name: 'Kruszelnickiego I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 292, name: 'Kruszelnickiego II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 293, name: 'Kruszelnickiego III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 294, name: 'Kruszelnickiego pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 295, name: 'Kryształowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 296, name: 'Kryształowa / os. Podkarczówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 297, name: 'Kusocińskiego / al. Na Stadion' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 298, name: 'Kusocińskiego szpital' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 299, name: 'Lekomin I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 300, name: 'Lekomin II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 301, name: 'Leszczyny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 302, name: 'Leszczyny I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 303, name: 'Leszczyny II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 304, name: 'Leszczyny III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 305, name: 'Leszczyny kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 306, name: 'Leszczyny Skała' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 307, name: 'Leszczyny szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 308, name: 'Leszczyny zalew' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 309, name: 'Leśniówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 310, name: 'Leśniówka / Ściegiennego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 311, name: 'Leśniówka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 312, name: 'Leśniówka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 313, name: 'Leśniówka III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 314, name: 'Lubiczna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 315, name: 'Łanowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 316, name: 'Łopuszniańska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 317, name: 'Łopuszniańska / Janów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 318, name: 'Łopuszniańska / Zgórska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 319, name: 'Łosień kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 320, name: 'Łosień szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 321, name: 'Łódzka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 322, name: 'Łódzka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 323, name: 'Łódzka Łazy' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 324, name: 'Łódzka Niewachlów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 325, name: 'Łubno' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 326, name: 'Łubno I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 327, name: 'Łubno II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 328, name: 'Malików' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 329, name: 'Malików I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 330, name: 'Malików pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 331, name: 'Malików wiadukt' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 332, name: 'Marszałkowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 333, name: 'Marszałkowska os. Sady' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 334, name: 'Masłów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 335, name: 'Masłów Drugi' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 336, name: 'Masłów Gmina' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 337, name: 'Masłów Kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 338, name: 'Masłów Nademłynie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 339, name: 'Masłów Pierwszy' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 340, name: 'Masłów Pierwszy / lotnisko' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 341, name: 'Masłów szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 342, name: 'Massalskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 343, name: 'Massalskiego I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 344, name: 'Mąchocice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 345, name: 'Mąchocice - Scholasteria' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 346, name: 'Mąchocice I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 347, name: 'Mąchocice II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 348, name: 'Mąchocice III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 349, name: 'Mąchocice IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 350, name: 'Mąchocice Kapitulne' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 351, name: 'Mąchocice Parcele' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 352, name: 'Mąchocice Zagórne' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 353, name: 'Mąchocice Zagórne I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 354, name: 'Micigózd' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 355, name: 'Micigózd / Częstochowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 356, name: 'Micigózd / Leśna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 357, name: 'Micigózd / Łąkowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 358, name: 'Micigózd / Starowiejska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 359, name: 'Micigózd Kolonia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 360, name: 'Miedziana' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 361, name: 'Miedziana Góra Ciosowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 362, name: 'Miedziana Góra I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 363, name: 'Miedziana Góra II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 364, name: 'Miedziana Góra Wykień' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 365, name: 'Miedziana Góra Zagórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 366, name: 'Mielczarskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 367, name: 'Miodowicza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 368, name: 'Młynek Brudzowski' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 369, name: 'Morawica I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 370, name: 'Morawica pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 371, name: 'Morawica szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 372, name: 'Morawica szpital' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 373, name: 'Morcinka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 374, name: 'Morcinka / działki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 375, name: 'Morcinka / Otrocz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 376, name: 'Mójcza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 377, name: 'Mójcza I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 378, name: 'Mójcza kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 379, name: 'Mójcza szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 380, name: 'Niestachów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 381, name: 'Niestachów I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 382, name: 'Niestachów II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 383, name: 'Niestachów III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 384, name: 'Niestachów IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 385, name: 'Niestachów kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 386, name: 'Niestachów pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 387, name: 'Niestachów skrzyż.' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 388, name: 'Niestachów szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 389, name: 'Niwy' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 390, name: 'Niwy II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 391, name: 'Nowaka - Jeziorańskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 392, name: 'Nowiny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 393, name: 'Nowiny I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 394, name: 'Nowiny Trzcianki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 395, name: 'Nowiny UG' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 396, name: 'Nowiny ul. Przemysłowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 397, name: 'Obice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 398, name: 'Obice I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 399, name: 'Obice Szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 400, name: 'Obice ul.Kielecka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 401, name: 'Okrzei / Zagnańska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 402, name: 'Okrzei rondo' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 403, name: 'Olszewskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 404, name: 'Olszewskiego / Łódzka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 405, name: 'Ołowiana' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 406, name: 'Orkana / os. Uroczysko' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 407, name: 'Orkana os. Związkowiec' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 408, name: 'Orląt Lwowskich' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 409, name: 'Orląt Lwowskich I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 410, name: 'Orląt Lwowskich II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 411, name: 'Os. Dąbrowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 412, name: 'Os. Kochanowskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 413, name: 'Os. Nowiny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 414, name: 'Os. Nowiny I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 415, name: 'Os. Podkarczówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 416, name: 'Os. Podzamcze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 417, name: 'Os. Sieje' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 418, name: 'Os. Sieje I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 419, name: 'Os. Ślichowice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 420, name: 'Os. Świętokrzyskie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 421, name: 'Os.Nowiny II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 422, name: 'Osobna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 423, name: 'Paderewskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 424, name: 'Paderewskiego / Sienkiewicza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 425, name: 'Pakosz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 426, name: 'Pakosz I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 427, name: 'Pawia / Skrzetlewska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 428, name: 'Piaseczna Górka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 429, name: 'Piaseczny Dół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 430, name: 'Piaseczny Dół II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 431, name: 'Piekoszowska / Kazimierza Wielkiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 432, name: 'Piekoszowska / Mieszka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 433, name: 'Piekoszowska / Naruszewicza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 434, name: 'Piekoszowska Czarnów Rządowy I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 435, name: 'Piekoszowska Górki Szczukowskie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 436, name: 'Piekoszowska II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 437, name: 'Piekoszowska Malików' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 438, name: 'Piekoszowska os.Pod Dalnią' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 439, name: 'Piekoszowska pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 440, name: 'Piekoszowska Stawki I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 441, name: 'Piekoszowska Stawki II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 442, name: 'Piekoszów / Sikorskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 443, name: 'Piekoszów Dom Opieki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 444, name: 'Piekoszów gimnazjum' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 445, name: 'Piekoszów III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 446, name: 'Piekoszów Jarzębiówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 447, name: 'Piekoszów Łaziska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 448, name: 'Piekoszów UG' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 449, name: 'Piekoszów ul. Wolności' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 450, name: 'Pietraszki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 451, name: 'Piwowarska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 452, name: 'Plac Artystów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 453, name: 'Pocieszka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 454, name: 'Podgród' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 455, name: 'Podklasztorna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 456, name: 'Podwiśniówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 457, name: 'Podwiśniówka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 458, name: 'Podwiśniówka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 459, name: 'Podwiśniówka III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 460, name: 'Podzamcze I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 461, name: 'Podzamcze II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 462, name: 'Podzamcze III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 463, name: 'Posłowice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 464, name: 'Posłowicka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 465, name: 'Posłowicka szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 466, name: 'Przęsłowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 467, name: 'Przyjmo' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 468, name: 'Radlin I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 469, name: 'Radlin II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 470, name: 'Radlin III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 471, name: 'Radlin IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 472, name: 'Radlin Niestachów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 473, name: 'Radlin skrzyż.' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 474, name: 'Radlin szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 475, name: 'Radlin V' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 476, name: 'Radomice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 477, name: 'Radomice I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 478, name: 'Radomice II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 479, name: 'Radomska / Warszawska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 480, name: 'Samsonów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 481, name: 'Samsonów I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 482, name: 'Sandomierska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 483, name: 'Sandomierska / Cmentarna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 484, name: 'Sandomierska / Morcinka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 485, name: 'Sandomierska / Śląska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 486, name: 'Sandomierska / Wikaryjska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 487, name: 'Sandomierska / Źródłowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 488, name: 'Sandomierska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 489, name: 'Sandomierska Nowy Folwark' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 490, name: 'Seminaryjska / Jana Pawła II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 491, name: 'Seminaryjska / Tarnowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 492, name: 'Seminaryjska / Żeromskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 493, name: 'Siedmiu Źródeł I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 494, name: 'Siedmiu Źródeł II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 495, name: 'Sikorskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 496, name: 'Sikorskiego I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 497, name: 'Sitkówka Jaskinia Raj' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 498, name: 'Skorzeszyce' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 499, name: 'Skorzeszyce I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 500, name: 'Skorzeszyce II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 501, name: 'Skorzeszyce III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 502, name: 'Skorzeszyce kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 503, name: 'Skorzeszyce pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 504, name: 'Skorzeszyce skrzyż.' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 505, name: 'Skrajna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 506, name: 'Skrajna I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 507, name: 'Skrzetlewska / Łódzka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 508, name: 'Smolaka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 509, name: 'Sołtysiaka "Barabasza"' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 510, name: 'Stadion' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 511, name: 'Sukowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 512, name: 'Sukowska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 513, name: 'Sukowska II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 514, name: 'Suków' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 515, name: 'Suków Babie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 516, name: 'Suków Babie I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 517, name: 'Suków Babie II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 518, name: 'Suków Babie III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 519, name: 'Suków Babie IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 520, name: 'Suków Borki' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 521, name: 'Suków I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 522, name: 'Suków Modrzewie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 523, name: 'Suków Modrzewie I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 524, name: 'Suków Piaskownia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 525, name: 'Suków Rogatka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 526, name: 'Szczecińska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 527, name: 'Szczecińska / Sandomierska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 528, name: 'Szczepaniaka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 529, name: 'Szczepaniaka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 530, name: 'Szczepaniaka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 531, name: 'Szczukowice' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 532, name: 'Szczukowice II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 533, name: 'Szczukowice III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 534, name: 'Szczukowice kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 535, name: 'Szczukowice wiadukt' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 536, name: 'Szewce' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 537, name: 'Szewce szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 538, name: 'Szewce wiadukt' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 539, name: 'Szybowcowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 540, name: 'Szybowcowa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 541, name: 'Szybowcowa kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 542, name: 'Ściegiennego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 543, name: 'Ściegiennego / Husarska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 544, name: 'Ściegiennego / I LO Żeromskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 545, name: 'Ściegiennego / Jawornia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 546, name: 'Ściegiennego / Podlasie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 547, name: 'Ściegiennego / Posłowicka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 548, name: 'Ściegiennego / Wapiennikowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 549, name: 'Ściegiennego cmentarz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 550, name: 'Ściegiennego I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 551, name: 'Ściegiennego II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 552, name: 'Ściegiennego lecznica' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 553, name: 'Ściegiennego piekarnia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 554, name: 'Ściegiennego stadion' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 555, name: 'Ściegiennego WDK' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 556, name: 'Ścięgna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 557, name: 'Świerczyny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 558, name: 'Świerczyny I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 559, name: 'Świerczyny II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 560, name: 'Świętokrzyska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 561, name: 'Świętokrzyska / Domaszowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 562, name: 'Świętokrzyska / Morcinka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 563, name: 'Świętokrzyska / Żniwna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 564, name: 'Świętokrzyska Galeria "Echo"' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 565, name: 'Świętokrzyska os. Bocianek' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 566, name: 'Świętokrzyska UJK' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 567, name: 'Targi Kielce' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 568, name: 'Tarnowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 569, name: 'Tarnowska / Prosta' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 570, name: 'Tarnowska / Wapiennikowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 571, name: 'Tarnowska / Wojska Pol.' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 572, name: 'Tarnowska Wietrznia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 573, name: 'Transportowców' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 574, name: 'Transportowców Makro' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 575, name: 'Trzuskawica ZPW' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 576, name: 'Tumlin / Dąbrówka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 577, name: 'Tumlin / Dąbrówka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 578, name: 'Tumlin / Szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 579, name: 'Tumlin / Wykień' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 580, name: 'Tumlin / Wykień II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 581, name: 'Tumlin Osowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 582, name: 'Tumlin Zacisze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 583, name: 'Tumlin zalew' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 584, name: 'Umer' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 585, name: 'Umer I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 586, name: 'Urząd Miasta' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 587, name: 'Wapiennikowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 588, name: 'Warszawska / al. IX Wieków Kielc' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 589, name: 'Warszawska / Jaworskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 590, name: 'Warszawska / Orkana' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 591, name: 'Warszawska / Politechnika' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 592, name: 'Warszawska / Sąd' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 593, name: 'Warszawska / Sikorskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 594, name: 'Warszawska / Szybowcowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 595, name: 'Warszawska / Witosa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 596, name: 'Warszawska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 597, name: 'Warszawska os. Bocianek' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 598, name: 'Warszawska os. Na Stoku' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 599, name: 'Warszawska os. Sady' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 600, name: 'Warszawska os. Sł. Wzgórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 601, name: 'Warszawska os. Szydłówek' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 602, name: 'Warszawska os. Uroczysko' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 603, name: 'Warszawska szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 604, name: 'Wikaryjska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 605, name: 'Wikaryjska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 606, name: 'Wikaryjska II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 607, name: 'Wincentego z Kielc I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 608, name: 'Wincentego z Kielc II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 609, name: 'Wincentów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 610, name: 'Wincentów I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 611, name: 'Wincentów II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 612, name: 'Wincentów III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 613, name: 'Wincentów IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 614, name: 'Wincentów Zręby' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 615, name: 'Wiśniówka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 616, name: 'Wiśniówka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 617, name: 'Witosa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 618, name: 'Witosa / Piwowarska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 619, name: 'Witosa / Zagnańska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 620, name: 'Witosa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 621, name: 'Witosa os. Dąbrowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 622, name: 'Witosa os. Sieje' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 623, name: 'Wojska Pol. / Jana Karskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 624, name: 'Wojska Pol. / Ostra Górka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 625, name: 'Wojska Pol. / Tarnowska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 626, name: 'Wojska Pol. J. W' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 627, name: 'Wojska Pol. Poliklinika' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 628, name: 'Wola Jachowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 629, name: 'Wola Jachowa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 630, name: 'Wola Jachowa skrzyż.' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 631, name: 'Wola Kopcowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 632, name: 'Wola Kopcowa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 633, name: 'Wola Kopcowa II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 634, name: 'Wola Kopcowa III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 635, name: 'Wola Kopcowa ogródki działkowe' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 636, name: 'Wola Kopcowa pętla' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 637, name: 'Wola Morawicka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 638, name: 'Wola Morawicka I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 639, name: 'Wola Morawicka II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 640, name: 'Wola Morawicka III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 641, name: 'Wola Murowana' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 642, name: 'Wola Murowana Kościół' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 643, name: 'Wola Murowana Straż Pożarna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 644, name: 'Wrzosowa / Ostra Górka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 645, name: 'Wrzosowa / Starostwo Powiatowe' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 646, name: 'Wrzosowa ogródki działkowe' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 647, name: 'Wrzosowa os. Podhale' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 648, name: 'Wrzosowa szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 649, name: 'Wyrowce' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 650, name: 'Za walcownią / Zalesie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 651, name: 'Zagnańsk / Słoneczna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 652, name: 'Zagnańsk / Turystyczna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 653, name: 'Zagnańsk / Turystyczna II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 654, name: 'Zagnańsk Chrusty' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 655, name: 'Zagnańsk szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 656, name: 'Zagnańsk tory' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 657, name: 'Zagnańsk UG' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 658, name: 'Zagnańska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 659, name: 'Zagnańska / Jesionowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 660, name: 'Zagnańska / Łódzka' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 661, name: 'Zagnańska / Piwowarska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 662, name: 'Zagnańska / Stolarska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 663, name: 'Zagnańska / Witosa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 664, name: 'Zagnańska Areszt' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 665, name: 'Zagnańska cmentarz' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 666, name: 'Zagnańska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 667, name: 'Zagnańska szkoła' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 668, name: 'Zagórska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 669, name: 'Zagórska / Kujawska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 670, name: 'Zagórska / Szczecińska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 671, name: 'Zagórska / Zagórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 672, name: 'Zagórska / Źródłowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 673, name: 'Zagórska / Żeromskiego' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 674, name: 'Zagórze' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 675, name: 'Zagórze / Mójcza' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 676, name: 'Zagórze II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 677, name: 'Zagórze III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 678, name: 'Zakładowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 679, name: 'Zalesie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 680, name: 'Zalesie / Janów' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 681, name: 'Zalesie Gaj' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 682, name: 'Zalesie I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 683, name: 'Zalesie II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 684, name: 'Zalesie III' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 685, name: 'Zalesie IV' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 686, name: 'Zastawie' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 687, name: 'Zastawie I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 688, name: 'Zawada' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 689, name: 'Zawada I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 690, name: 'Zelejowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 691, name: 'Zelejowa I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 692, name: 'Zgórsko' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 693, name: 'Zgórsko os. Nowiny' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 694, name: 'Zgórsko os."Pod Lasem"' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 695, name: 'Źródłowa' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 696, name: 'Źródłowa / Jarońskich' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 697, name: 'Żelazna PKP' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 698, name: 'Żelaznogórska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 699, name: 'Żelaznogórska I' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 700, name: 'Żelaznogórska II' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 701, name: 'Żeromskiego / Seminaryjska' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 702, name: 'Żniwna' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 703, name: 'Żytnia' });
    this.przystanekAutobusowy.push(tmp);
    tmp = ({ id: 704, name: 'Żytnia I' });
    this.przystanekAutobusowy.push(tmp);
  }
}



// WEBPACK FOOTER //
// ./src/app/stops/stops.service.ts